import { render, staticRenderFns } from "./IntakeAssistTasks.vue?vue&type=template&id=3b1e3564&scoped=true"
import script from "./IntakeAssistTasks.vue?vue&type=script&lang=js"
export * from "./IntakeAssistTasks.vue?vue&type=script&lang=js"
import style0 from "./IntakeAssistTasks.vue?vue&type=style&index=0&id=3b1e3564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e3564",
  null
  
)

export default component.exports